/* istanbul ignore file */
import { useState } from "react";

type HasId = {
  id: string;
};

export const useSelectable = <T extends HasId>(items: T[]) => {
  const [selected, setSelected] = useState(new Map<string, boolean>());

  const selectedItems = [...selected.entries()]
    .filter(([_, v]) => !!v)
    .map(([k]) => k);

  const totalSelected = selectedItems.length;

  const isAllSelected = items.length !== 0 && items.length === totalSelected;

  const deleteFromSelected = (ids: string[]) => {
    setSelected((previous) => {
      const next = new Map(previous);
      ids.forEach((id) => {
        next.delete(id);
      });
      return next;
    });
  };

  const toggleSelected = (ids: string[]) => {
    setSelected((previous) => {
      const next = new Map(previous);
      ids.forEach((id) => {
        next.set(id, !next.get(id));
      });
      return next;
    });
  };

  const setAllSelectedTo = (value: boolean, filter?: (item: T) => boolean) => {
    setSelected(() => {
      const filteredItems = filter ? items.filter(filter) : items;
      const next = new Map(filteredItems.map(({ id }) => [id, value]));
      return next;
    });
  };

  const clearSelected = () => {
    setSelected(new Map());
  };

  return {
    selected,
    setSelected,
    isAllSelected,
    deleteFromSelected,
    toggleSelected,
    setAllSelectedTo,
    clearSelected,
    totalSelected,
    selectedItems,
  };
};
